var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-font',{staticClass:"breadcrumb",attrs:{"tag":"span","color":"secondary","size":"xs","weight":"medium"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }